export const checkSessionExpiration = (expirationDate) => {
    const now = new Date();
    const expiration = new Date(expirationDate);
    return now >= expiration; // true si la sesión expiró
};

export default checkSessionExpiration;